module.exports = __webpack_public_path__ + "media/images/SP-House-Yamori-Image-647c1813916379cef94a3e85fe0a3315.png";